import { useEffect } from "react";
import useSeo, { type SeoConfig } from "@/hooks/useSeo";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

interface SiteLayoutProps {
  children: React.ReactNode;
  title?: string;
  description?: string;
  keywords?: string;
  scrollToTop?: boolean;
}

export default function SiteLayout({
  children,
  title,
  description,
  keywords,
  scrollToTop = true,
}: SiteLayoutProps) {
  useSeo({ title, description, keywords } as SeoConfig);

  useEffect(() => {
    if (scrollToTop) window.scrollTo({ top: 0, behavior: "auto" });
  }, [scrollToTop]);

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}